export default "__VITE_ASSET__y9jG7R4T__"